import React from 'react';
import { useLiveVisitors } from '../hooks/useLiveVisitors';
export function LiveVisitorsBanner() {
  const visitors = useLiveVisitors();
  return <div className="bg-brand-light/40 border-b border-brand-primary/20 py-2 text-center text-sm font-medium text-brand-text/80 mt-[72px] sm:mt-[76px]" data-id="element-65">
      <div className="flex items-center justify-center gap-2" data-id="element-66">
        <span className="relative flex h-3 w-3" data-id="element-67">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-68"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-69"></span>
        </span>
        <span data-id="element-70">
          <strong className="text-brand-primary" data-id="element-71">{visitors}</strong> personas
          están viendo esta página ahora mismo
        </span>
      </div>
    </div>;
}